import { Card, CardContent } from '@/components/ui/card';
import { KeyRound, Vote, Shield, Zap } from 'lucide-react';

const steps = [
  {
    icon: KeyRound,
    title: 'Get a Nostr Key',
    description: 'Create a free Nostr identity. No email, no phone number, no corporate overlords. Just a cryptographic key pair that you own.',
    accent: 'from-primary/20 to-primary/5',
  },
  {
    icon: Vote,
    title: 'Vote in Each Round',
    description: 'Cast your vote in every bracket matchup. Who\'s the biggest Bitcoin maximalist? You decide.',
    accent: 'from-primary/15 to-primary/5',
  },
  {
    icon: Shield,
    title: 'Censorship-Proof',
    description: 'Your votes are recorded on the Nostr protocol. No central authority can delete or alter them. Ever.',
    accent: 'from-primary/10 to-primary/5',
  },
  {
    icon: Zap,
    title: 'The Ultimate Maxi',
    description: 'The bracket narrows round by round until only one remains. The people\'s champion of Bitcoin maximalism.',
    accent: 'from-primary/20 to-primary/5',
  },
];

export function HowItWorks() {
  return (
    <section className="relative py-16 sm:py-24">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-14 space-y-3">
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-foreground">
            How It <span className="text-bitcoin-gradient">Works</span>
          </h2>
          <p className="text-muted-foreground text-sm sm:text-base max-w-lg mx-auto">
            Voting powered by Nostr. Sovereign, verifiable, unstoppable.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <Card
                key={step.title}
                className="group relative overflow-hidden border-border/30 bg-card/60 backdrop-blur-sm hover:border-primary/20 transition-all duration-500 opacity-0 animate-fade-in-up"
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                <div className={`absolute inset-0 bg-gradient-to-br ${step.accent} opacity-0 group-hover:opacity-100 transition-opacity duration-500`} />
                <CardContent className="relative p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary/20 transition-colors duration-300">
                      <Icon className="w-5 h-5 text-primary" />
                    </div>
                    <div className="space-y-1.5">
                      <div className="flex items-center gap-2">
                        <span className="text-xs font-bold text-primary/50 tabular-nums">0{index + 1}</span>
                        <h3 className="text-base font-semibold text-foreground">{step.title}</h3>
                      </div>
                      <p className="text-sm text-muted-foreground leading-relaxed">
                        {step.description}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
}
